export default {
    //资讯收藏列表
    getCollects (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/archive/collects', {
                params:params 
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //帖子收藏列表
    getbbsCollects (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/bbs/collects',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    //问答收藏列表
    getaskCollects (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/ask/collects',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    }
}